import { forreston } from '@ourbranch/brand-product';
import { createColorPalette } from '@ourbranch/ui-core';
import { withBrandProduct } from '../../lib/with-brand-product';
const frontendConfig = {
    constants: {
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '800-938-2270',
        CLAIMS_PHONE: '800-938-2270',
        // TODO: update once forreston has set up a claims email
        CLAIMS_EMAIL: '#',
        // #36703: the insured portal's "File a claim" modal links members to the Forreston FNOL form (same page the
        // Staff help speed dial uses, #35911).
        CLAIMS_FNOL_LINKS: [{ label: 'File a claim online', url: 'https://forreston.ember.liberate.claims/fnol' }],
        AGENCY_SUPPORT_PHONE: '(800) 938-2270',
        AGENCY_SUPPORT_HOURS: 'Mon-Fri, 8am-4pm Central',
        MEMBER_COMMS_EMAIL: 'this-is@a.placeholder',
        SMS_SHORTCODE: '',
        // TODO: Get terms of use URL for Forreston
        TERMS_OF_USE_URL: '#',
        // TODO: Get communications consent URL for Forreston
        COMMUNICATIONS_CONSENT_URL: '#',
        IOS_APP_STORE_URL: '#',
        ANDROID_GOOGLE_PLAY_STORE_URL: '#',
        // Blank: the credit-card fee note is inaccurate for this mutual (#33401).
        SMALL_BILLING_NOTE: ''
    },
    theme: {
        palette: createColorPalette({
            primaryMain: '#A6192E',
            backgroundsMain: '#F0F0F0',
            typographyMain: '#3A3A3A',
            controlsMain: '#D4D0CD',
            errorMain: '#7A0027'
        }),
        loaderColor: '#BB6058',
        showLogoInLoader: false,
        showAccountBackgroundHero: false,
        logoWidthDesktop: 320,
        logoWidthMobile: 230
    },
    config: {
        supportedFees: {
            creditCard: true
        }
    }
};
const brand = withBrandProduct(forreston, frontendConfig);
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
